/* eslint-disable prefer-arrow-callback */
/* eslint-disable prefer-template */
/**
 * Layer Type: HP Listing Posts Slider
 *
 * @package  embark
 * @since    1.0.0
 */

/**
 * Import dependencies.
 */
import $ from 'jquery';
import 'slick-carousel';

/**
 * Slider layers
 *
 * @type {NodeList}
 */

/**
 * Do synchronized slick sliders.
 * Note: when window is resized slick slider is register, or deregistered.
 */
function initblockHP2ListingPostsSlider() {
	// Check screen width
	const blockHP2ListingPostsSliderScreenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

	const blockHP2ListingPostsSlider = document.querySelectorAll('.hp2-listing-posts');

	if (blockHP2ListingPostsSlider.length > 0) {
		// Run the logic if screen is bellow specified width. If not deregister the slick slider.
		if (blockHP2ListingPostsSliderScreenWidth < 641) {
			$(blockHP2ListingPostsSlider).each(
				function () {
					// This layer instance.
					// const $this = $(this);

					// This layer's content slider.
					const $slider = $(this).find('.hp2-listing-posts__listing');

					// Check if slider is already initialized by checking CSS Class 'slick-initialized'.

					if (!$slider.hasClass('slick-initialized')) {
						if (($slider.find('.em-card-listing-post').length < 2)) {
							// Hide navigation if there is less than 2 items.
							$('.hp2-listing-posts__slider-navigation').hide();
						}

						// Initialize slider if more than one slide.
						if ($slider.find('.em-card-listing-post').length > 1) {
							// Content slider properties.
							const sliderProps = {
								adaptiveHeight: true,
								arrows: null,
								dots: false,
								draggable: true,
								fade: true,
								autoplay: false,
								autoplaySpeed: 8000,
								pauseOnHover: true,
								speed: 1000,
								cssEase: 'ease',
							};

							// Initialize the content slider.
							$slider.slick(sliderProps);

							// Custom prev/next links.
							$('.hp2-listing-posts__slider-next').on('click', function () {
								$slider.slick('slickNext');
							});

							$('.hp2-listing-posts__slider-prev').on('click', function () {
								$slider.slick('slickPrev');
							});

							// On hover, pause.
							$slider.on('mouseover', function () {
								$slider.slick('pause');
							});

							// On hover, pause.
							$slider.on('mouseout', function () {
								$slider.slick('play');
							});
						}
					}
				},
			);
		} else {
			$(blockHP2ListingPostsSlider).each(
				function () {
					// This layer's content slider.
					const $slider = $(this).find('.hp2-listing-posts__listing');

					// Check if slider is already initialized by checking CSS Class 'slick-initialized'.
					if ($slider.hasClass('slick-initialized')) {
						// Deregister Slick Slider.
						$slider.slick('unslick');
					}
				},
			);
		}
	}
}

// Run the script based on initial content
window.addEventListener('DOMContentLoaded', initblockHP2ListingPostsSlider);

// Run the script if window is resized
window.addEventListener('resize', initblockHP2ListingPostsSlider);
